import $ from 'jquery';
import { fetchAiCredits } from '~graphql/controllers';
import { fetchCreditModules } from '~src/~core/payments';
import { handleBuyAiCredits } from './handleBuyAiCredits';

export const initAiCreditPackagesModal = () => {
  // Remove existing listeners to prevent duplicates
  $(document).off('click.aiCreditPackages', '#credits-info-btn');
  $('#aiCreditPackagesModal').off('show.bs.modal.aiCreditPackages');
  $('#aiCreditPackagesModal').off('hidden.bs.modal.aiCreditPackages');
  $('#aiCreditPackagesModal').off('shown.bs.modal.aiCreditPackages');

  // Handle credits info button click
  $(document).on('click.aiCreditPackages', '#credits-info-btn', function (e) {
    e.preventDefault();
    $('#aiCreditPackagesModal').modal('hide');

    // Wait for modal to be fully hidden before showing the next one
    setTimeout(function () {
      $('#aiCreditsInfoModal').modal('show');
      // Ensure body has modal-open class and backdrop is correct
      $('body').addClass('modal-open');
    }, 500);
  });

  // Prevent ESC key from propagating to global handlers when modal is shown
  $('#aiCreditPackagesModal').on('show.bs.modal.aiCreditPackages', function () {
    $(this).on('keydown.aiModal', function (e) {
      if (e.keyCode === 27) {
        e.stopPropagation();
      }
    });
  });

  // Clean up event handler when modal is hidden
  $('#aiCreditPackagesModal').on(
    'hidden.bs.modal.aiCreditPackages',
    function () {
      $(this).off('keydown.aiModal');
    }
  );

  // Load packages when modal opens
  $('#aiCreditPackagesModal').on(
    'shown.bs.modal.aiCreditPackages',
    async function () {
      const container = $('#creditPackagesContainer');

      // Show loading state
      container.html(`
      <div class="col-12 loading-placeholder">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Caricamento...</span>
        </div>
        <p class="mt-3">Caricamento pacchetti disponibili...</p>
      </div>
    `);

      try {
        // Fetch current credits
        const credits = await fetchAiCredits();
        const totalCredits =
          credits.edges[0].freeCreditsAmount +
          credits.edges[0].paidCreditsAmount;
        $('#currentCreditsBalance').text(totalCredits);

        // Fetch available packages
        const modules = await fetchCreditModules();

        if (!modules || modules.length === 0) {
          container.html(`
          <div class="col-12 text-center">
            <p class="text-muted">Nessun pacchetto disponibile al momento.</p>
          </div>
        `);
          return;
        }

        // Sort modules by quantity
        modules.sort((a, b) => a.included_quantity - b.included_quantity);

        // Generate package cards
        let packagesHtml = '';
        modules.forEach((module, index) => {
          const totalCost =
            module.price_for_quantity * module.included_quantity;
          const totalPrice = totalCost.toFixed(2);
          const unitPrice = (totalCost / module.included_quantity).toFixed(2);

          // Check if this is the recommended package (usually the middle one)
          const isRecommended = index === Math.floor(modules.length / 2);

          // Calculate savings for larger packages
          const basePricePerCredit = modules[0]
            ? modules[0].price_for_quantity
            : 0;
          const currentPricePerCredit = totalCost / module.included_quantity;
          const savingsPercent =
            basePricePerCredit > 0
              ? Math.round(
                  (1 - currentPricePerCredit / basePricePerCredit) * 100
                )
              : 0;

          packagesHtml += `
          <div class="col-md-6 col-lg-3 mb-3">
            <div class="package-card ${isRecommended ? 'recommended' : ''}" 
              data-module-id="${module.objectId}" 
              data-module-name="${module.name}" 
              data-module-quantity="${module.included_quantity}" 
              data-module-price="${totalPrice}">
              <div class="package-credits mb-2">
                ${module.included_quantity} 
                <span class="text-muted">${
                  module.included_quantity === 1 ? 'credito' : 'crediti'
                }</span>
              </div>
              <div class="package-price mb-1">€${totalPrice} <small class="text-muted">i.e.</small></div>
              <div class="package-unit-price mb-3">€${unitPrice}/credito</div>
              ${
                savingsPercent > 0
                  ? `<div class="package-savings">Risparmi il ${savingsPercent}%</div>`
                  : '<div style="height: 20px;"></div>'
              }
            </div>
          </div>
        `;
        });

        container.html(packagesHtml);

        // Handle package selection - make entire card clickable
        // Remove any existing handlers first
        $('.package-card').off('click.aiPackageSelect');
        $('.package-card').on('click.aiPackageSelect', async function (e) {
          e.preventDefault();
          const packageCard = $(this).closest('.package-card');
          const moduleId = packageCard.data('module-id');
          const moduleName = packageCard.data('module-name');
          const moduleQuantity = packageCard.data('module-quantity');
          const modulePrice = packageCard.data('module-price');

          // Close this modal
          $('#aiCreditPackagesModal').modal('hide');

          // Call the existing payment handler with pre-selected module
          handleBuyAiCredits({
            title: 'Conferma Acquisto',
            html: `
            <div class="text-center">
              <h5>${moduleName}</h5>
              <p class="lead">${moduleQuantity} crediti per €${modulePrice}</p>
              <p class="text-muted">I crediti saranno disponibili immediatamente dopo il pagamento.</p>
            </div>
          `,
            inputValue: moduleId,
            showCancelButton: true,
            confirmButtonText: 'Procedi al pagamento',
            cancelButtonText: 'Annulla',
          });
        });
      } catch (error) {
        console.error('Error loading credit packages:', error);
        container.html(`
        <div class="col-12 text-center">
          <p class="text-danger">Errore nel caricamento dei pacchetti. Riprova più tardi.</p>
        </div>
      `);
      }
    }
  );
};
